import type { TPasswordStrength } from './password.util.type';

const superStrongRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=(.*[-+_!@#$%^&*.,?]){2})(?!.*\s).{18,32}/;
const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*.,?])(?=.{10,32})/;
const mediumRegex =
  /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*\d))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,32})/;

export const getPasswordStrength = (password: string): TPasswordStrength => {
  if (superStrongRegex.test(password)) {
    return 'superStrong';
  }
  if (strongRegex.test(password)) {
    return 'strong';
  }
  if (mediumRegex.test(password)) {
    return 'medium';
  }

  return 'weak';
};
